// The day something just landed on (someone put on it from Due, a visit just booked): the Diary lights it up once
// when it is next drawn (diary-layout.ts finishDiary; the movement set's land, motion.css). Kept on its own so the
// booking panel can mark a day without loading the Diary's styles.
// Only while the Diary is the page, and only for the next few seconds: a booking made from a customer's page, or one
// whose redraw never came, never lights up a day later on (Astra, 24 Oct 2026).
// The Diary is also what an owner sees with no page in the address (main.ts route).
const onDiary = (): boolean => typeof location !== 'undefined' && (['', '#', '#/'].includes(location.hash) || location.hash.startsWith('#/schedule'))
let landing: { date: string; at: number } | null = null
export function diaryLandOn(date: string): void { landing = onDiary() ? { date, at: Date.now() } : null }
export function takeLanding(): string | null {
  const was = landing; landing = null
  return was && onDiary() && Date.now() - was.at < 8000 ? was.date : null
}
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') window.addEventListener('hashchange', () => { if (!onDiary()) landing = null })
